export default "__VITE_ASSET__24a538b1__"